import { FelaCSSWithCustomSelectors } from '@bridebook/ui/src/components/fela/flowtypes';
import { colors } from '@bridebook/ui';

interface IStylesArgs {
  showControlsOnHover: boolean;
}

interface IStyles {
  wrapper: FelaCSSWithCustomSelectors;
}

export const componentStyles = ({ showControlsOnHover }: IStylesArgs): IStyles => ({
  wrapper: {
    position: 'relative',

    '& .alice-carousel__dots': {
      opacity: 0.75,
      margin: 0,
      position: 'absolute',
      display: 'flex',
      flexDirection: 'row',
      gap: '4px',
      bottom: '8px',
      left: '50%',
      transform: 'translateX(-50%)',
      padding: '3px 5px',
      borderRadius: '10px',
      backgroundColor: 'rgba(26, 44, 64, 0.5)',
      transition: 'all 150ms',

      '& .alice-carousel__dots-item': {
        margin: 0,
        width: '7px',
        height: '7px',
        backgroundColor: colors.space60,
        transition: 'background-color 150ms',

        hover: {
          backgroundColor: colors.space40,
        },

        '&.__active': {
          backgroundColor: colors.white,

          hover: {
            backgroundColor: colors.white,
          },
        },
      },
    } as FelaCSSWithCustomSelectors,

    '& .alice-carousel__prev-btn, & .alice-carousel__next-btn': {
      position: 'absolute',
      top: '50%',
      width: 30,
      zIndex: 10,
      transform: 'translateY(-50%)',
      transition: 'all 150ms ease-out',
      padding: 0,
      ...(showControlsOnHover && {
        opacity: 0,
      }),
    },

    '& .alice-carousel__prev-btn': {
      left: 10,
      transform: `translateX(${showControlsOnHover ? '-6px' : 0}) translateY(-50%)`,
    },

    '& .alice-carousel__next-btn': {
      right: 10,
      transform: `translateX(${showControlsOnHover ? '6px' : 0}) translateY(-50%)`,
    },

    ...(showControlsOnHover && {
      hover: {
        '& .alice-carousel__prev-btn': {
          opacity: 1,
          transform: `translateX(0) translateY(-50%)`,
        },
        '& .alice-carousel__next-btn': {
          opacity: 1,
          transform: `translateX(0) translateY(-50%)`,
        },
        '& .alice-carousel__dots': {
          opacity: 1,
        },
      } as FelaCSSWithCustomSelectors,
    }),
  },
});
